import { Box, Stack, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { LoadMore } from "../../components/LoadMore";
import { Title } from "../../components/Title";
import { ParticipantRole } from "../../graphql";
import { useAllCalls } from "../../hooks";
import { formatDateTime, getFullName } from "../../utils";



import { AllCallsFilter } from "../Call/filter";
import { GetCallStatus } from "../Call/utils";

export const AllCalls: React.FC = () => {
    const {
        loading,
        items,
        loadMore,
        hasNextPage,
        totalCount,
        refresh
    } = useAllCalls();

    return (
        <>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Title title="Lista e telefonatave">
                    <AllCallsFilter
                        onChange={ (data) => {
                            refresh(data);
                        } }
                    />
                </Title>

                <Table variant="striped" size="sm" marginTop="15px">
                    <Thead>
                        <Tr>
                            <Th>Mjeku</Th>
                            <Th>Telefonuesi</Th>
                            <Th>Të ftuar</Th>
                            <Th>Statusi</Th>
                            <Th>Data</Th>
                            <Th>Kohëzgjatja</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        { items?.map((call) => {
                            const participants = call.participants;

                            const caller = participants.find(
                                (p) => p.role === ParticipantRole.Caller
                            );
                            const callee = participants.find(
                                (p) => p.role === ParticipantRole.Callee
                            );
                            const guests = participants.filter(
                                (p) => p.role === ParticipantRole.GuestCallee
                            );

                            return (
                                <Tr key={ call.id }>
                                    <Td>
                                        { callee?.account ? (
                                            <Link to={ `/call/${call.id}` }>
                                                <AccountAvatar
                                                    key={ callee?.account?.id }
                                                    account={ callee?.account }
                                                    size="xs"
                                                    role={ false }
                                                />
                                            </Link>
                                        ) : null }
                                    </Td>
                                    <Td>
                                        <Link to={ `/call/${call.id}` }>
                                            <AccountAvatar
                                                key={ caller?.account?.id }
                                                account={ caller?.account }
                                                size="xs"
                                                role={ false }
                                            />
                                        </Link>
                                    </Td>
                                    <Td>
                                        <Link to={ `/call/${call.id}` }>
                                            <Stack direction="row">
                                                { guests.length > 0
                                                    ? guests.map((participant) => (
                                                        <AccountAvatar
                                                            key={ participant?.account.id }
                                                            account={ participant?.account }
                                                            size="xs"
                                                            role={ false }
                                                        />
                                                    ))
                                                    : "Asnjë" }
                                            </Stack>
                                        </Link>
                                    </Td>
                                    <Td>
                                        <Link to={ `/call/${call.id}` }>
                                            <GetCallStatus call={ call } />
                                        </Link>
                                    </Td>
                                    <Td>
                                        <Link to={ `/call/${call.id}` }>
                                            { call.requestTime
                                                ? formatDateTime(call.requestTime)
                                                : "-" }
                                        </Link>
                                    </Td>
                                    <Td>
                                        <Link to={ `/call/${call.id}` }>{ call.duration } minuta </Link>
                                    </Td>
                                </Tr>
                            );
                        }) }
                    </Tbody>
                </Table>

                <LoadMore hasNextPage={ hasNextPage } loadMore={ loadMore } />
            </Box>
        </>
    );
};
